import { Box, Dialog, DialogTitle, DialogContent } from '@mui/material';
import closeModal from '../../../assets/images/icons/close-modal.png';

const style = {
  position: 'fixed',
  borderRadius: '8px',
  textAlign: 'left',
  padding: 2,

  '.MuiPaper-root': {
    overflowY: 'initial',
  },

  img: {
    position: 'absolute',
    top: -20,
    right: -20,
    overflow: 'visible',
    cursor: 'pointer',
  },
  h2: {
    fontSize: '24px',
    fontWeight: 700,
    color: theme => theme.palette.primary.main,
  },
  p: {
    fontSize: '18px',
    fontWeight: 500,
    color: theme => theme.palette.primary.grayText,
  },
};

export default function ModalInfo({ title, description, isOpen, handleClose }) {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      scroll="paper"
      sx={style}
      maxWidth="lg"
    >
      <Box component="img" src={closeModal} alt="Close" onClick={handleClose} />
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{description}</DialogContent>
    </Dialog>
  );
}
